import script from "./AccountTypeFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountTypeFilter.vue?vue&type=script&setup=true&lang=ts"

import "./AccountTypeFilter.vue?vue&type=style&index=0&id=b5fa9efc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5fa9efc"]])

export default __exports__